import api from '../api';

const parseTransactionSummary = apiResponse => {
  const { data = [], summary = {}, attempts: rawAttempts } = apiResponse || {};
  const attempts = Array.isArray(rawAttempts) ? rawAttempts : [];

  const transactionTypeMap = {
    I: 'id_capture',
    V: 'verification',
    O: 'onboarding',
    R: 'rest_api',
  };

  const dailyData = {};

  data.forEach(transaction => {
    const { date, amount = 0, quantity = 0, transaction_type } = transaction;
    const mappedType = transactionTypeMap[transaction_type];

    if (!dailyData[date]) {
      dailyData[date] = {
        date,
        total_count: 0,
        total_amount: 0,
        transactions: {
          onboarding: { count: 0, amount: 0 },
          verification: { count: 0, amount: 0 },
          id_capture: { count: 0, amount: 0 },
          rest_api: { count: 0, amount: 0 },
        },
      };
    }

    dailyData[date].total_count += quantity;
    dailyData[date].total_amount += amount;

    if (mappedType && dailyData[date].transactions[mappedType]) {
      dailyData[date].transactions[mappedType].count += quantity;
      dailyData[date].transactions[mappedType].amount += amount;
    }
  });

  return {
    summary: {
      total_count: summary.total_count || 0,
      total_amount: summary.total_amount || 0,
      currency: summary.currency || 'USD',
      attempts,
    },
    daily: dailyData,
  };
};

export const getTransactionSummary = async params => {
  return api
    .get('/v0/transactions/summary', { params })
    .then(({ data }) => parseTransactionSummary(data));
};

export const sendTransactionSummary = async params => {
  return api.post('/v0/transactions/summary', {}, { params })
    .then(({ data }) => data);
};
